let stateStore = new Map();

export function storeState(className, state) {
  stateStore.set(className, state);
}

export function getState(className) {
  return stateStore.get(className);
}
